import type { TFunction } from 'i18next';
import { ApiError } from './api.ts';

/** Translated text for an error from the API, or a generic text for anything else. */
export function errorText(t: TFunction, error: unknown): string {
  if (error instanceof ApiError) return t(`errors.${error.code}`);
  return t('errors.internal');
}

/** Translated text per form field, from an API validation error. */
export function fieldErrors(t: TFunction, error: unknown): Record<string, string> {
  if (!(error instanceof ApiError) || !error.fields) return {};
  return Object.fromEntries(Object.entries(error.fields).map(([field, code]) => [field, t(`errors.${code}`)]));
}
